#import "@/apollo/fragments/Annotation.gql"

mutation ChangeQAAnnotationStatusOnComputedDeliverable($annotationId: ID!, $annotationStatus: AnnotationStatus!) {
    changeQAAnnotationStatusOnComputedDeliverable(annotationId: $annotationId, annotationStatus: $annotationStatus) {
        ...Annotation
    }
}
